import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { useEffect, useState } from "react";

import Login from "./pages/Login";
import Pos from "./pages/Pos";
import SalesDetail from "./pages/SalesDetail";
import Clients from "./pages/Clients";
import Products from "./pages/Products";
import Suppliers from "./pages/Suppliers";
import Purchase from "./pages/Purchase";
import InvoiceList from "./pages/invoices/InvoiceList";
import CreditNotes from "./pages/CreditNotes";
import Reports from './pages/reports/Reports';
import InventoryAdjustments from "./pages/InventoryAdjustments";
import InventoryLoad from "./pages/InventoryLoad";
import ContingenciaEventos from "./pages/ContingenciaEventos";
import ContingenciaBanner from "./components/ContingenciaBanner";

// Importaciones de Caja
import CashRegister from './components/cash/CashRegister';
import CashSessionHistory from "./components/cash/CashSessionHistory";
import CashSessionDetail from "./components/cash/CashSessionDetail";

import Sidebar from "./components/Sidebar";
import TopBar from "./components/TopBar";
import PrivateRoute from "./components/PrivateRoute";

function EncargadoRoute({ children }) {
  const { isEncargado } = useAuth();
  if (!isEncargado) {
    return <Navigate to="/pos" replace />;
  }
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  // Estado para controlar si el sidebar está abierto en móvil
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Prevenir que el scroll cambie valores en inputs number
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement?.type === 'number') {
        document.activeElement.blur();
      }
    };
    document.addEventListener('wheel', handleWheel, { passive: true });
    return () => document.removeEventListener('wheel', handleWheel);
  }, []);

  // Cerrar sidebar al cambiar de ruta en móvil
  useEffect(() => {
    setSidebarOpen(false);
  }, [window.location.pathname]);

  // Aplicar/quitar clase en el elemento .sidebar según estado
  useEffect(() => {
    const sidebarEl = document.querySelector('.sidebar');
    const overlayEl = document.querySelector('.sidebar-overlay');
    if (sidebarEl) {
      sidebarEl.classList.toggle('sidebar-open', sidebarOpen);
    }
    if (overlayEl) {
      overlayEl.classList.toggle('show', sidebarOpen);
    }
    // Bloquear scroll del body cuando el sidebar está abierto en móvil
    if (window.innerWidth <= 768) {
      document.body.style.overflow = sidebarOpen ? 'hidden' : '';
    }
  }, [sidebarOpen]);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  const closeSidebar = () => setSidebarOpen(false);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={user ? <Navigate to="/pos" replace /> : <Navigate to="/login" replace />}
      />

      <Route
        path="/login"
        element={user ? <Navigate to="/pos" replace /> : <Login />}
      />

      <Route
        path="/*"
        element={
          <PrivateRoute>
            <div className="d-flex">

              {/* Overlay oscuro — clic cierra el sidebar */}
              <div className="sidebar-overlay" onClick={closeSidebar}></div>

              {/* Sidebar recibe estado para cerrar al navegar */}
              <Sidebar onClose={closeSidebar} />

                <div className="main-content">
                <ContingenciaBanner />
                {/* TopBar recibe función para abrir/cerrar sidebar */}
                <TopBar onMenuToggle={toggleSidebar} />

                <div className="content-wrapper">
                    <Routes>
                    {/* Acceso para todos */}
                    <Route path="/pos" element={<Pos />} />
                    <Route path="/sales/:id" element={<SalesDetail />} />
                    <Route path="/invoices" element={<InvoiceList />} />
                    <Route path="/cash" element={<CashRegister />} />
                    <Route path="/cash/history" element={<CashSessionHistory />} />
                    <Route path="/cash/session/:id" element={<CashSessionDetail />} />
                    <Route path="/inventory-adjustments" element={<InventoryAdjustments />} />
                    <Route path="/inventory-load" element={<InventoryLoad />} /> 
                    <Route path="/clients" element={<Clients />} />

                    {/* Solo encargado */}
                    <Route path="/products" element={<EncargadoRoute><Products /></EncargadoRoute>} />
                    <Route path="/purchase" element={<EncargadoRoute><Purchase /></EncargadoRoute>} />
                    <Route path="/suppliers" element={<EncargadoRoute><Suppliers /></EncargadoRoute>} />
                    <Route path="/reports" element={<EncargadoRoute><Reports /></EncargadoRoute>} />
                    <Route path="/credit-notes" element={<EncargadoRoute><CreditNotes /></EncargadoRoute>} />
                    <Route path="/contingencia" element={<EncargadoRoute><ContingenciaEventos /></EncargadoRoute>} />
                    <Route path="*" element={<h4>Página no encontrada</h4>} />
                  </Routes>
                </div>
              </div>

            </div>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;